import { colors as g } from "../../foundations/colors.es.js";
import "../../foundations/shadows.es.js";
import { hexToRgbaString as c } from "../../../utils/colors.es.js";
import { a as t } from "../../../chunk-OA3DH5LS-40f95340.js";
import { createMultiStyleConfigHelpers as o } from "@chakra-ui/react";
import { Input as e } from "../atoms/Input.es.js";
const p = t("SavedListItem").parts(
  "checkbox",
  "content",
  "contentAdditional",
  "root"
), { defineMultiStyleConfig: m } = o(
  p.keys
), I = m({
  baseStyle: {
    checkbox: {
      opacity: 0,
      position: "absolute",
      top: 0,
      right: 0,
      padding: 4,
      _groupHover: {
        opacity: 1
      },
      _groupChecked: {
        opacity: 1
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      "p + p": {
        marginTop: 0
      }
    },
    contentAdditional: {
      marginLeft: "auto",
      marginRight: 2,
      alignSelf: "flex-end",
      p: {
        display: "inline-flex",
        alignItems: "center",
        gap: 1
      }
    },
    root: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "stretch",
      gap: 4,
      order: 9999999,
      position: "relative",
      padding: 2,
      backgroundColor: "white",
      borderRadius: "radius-200",
      borderColor: "primary.100",
      borderStyle: "solid",
      borderWidth: "1px",
      cursor: "pointer",
      "*": { userSelect: "none" },
      _checked: {
        borderColor: "secondary.500",
        backgroundColor: c(g.secondary[50], 0.2),
        _hover: {
          borderColor: "secondary.500"
        }
      },
      _disabled: {
        opacity: 0.5,
        pointerEvents: "none"
      },
      _hover: {
        borderColor: "primary.300"
      }
    }
  },
  variants: {
    center: {
      root: {
        alignItems: "center",
        paddingRight: "spacing-200"
      }
    }
  },
  sizes: {},
  defaultProps: {}
}), L = t("SavedList").parts("root"), { defineMultiStyleConfig: y } = o(
  p.keys
), k = y({
  baseStyle: {},
  variants: {},
  sizes: {},
  defaultProps: {}
}), f = t("SavedListItemEdit").parts(
  "avatar",
  "content",
  "header",
  "root",
  "textareaClear",
  "textareaGroup",
  "textarea",
  "paragraph"
), { defineMultiStyleConfig: u } = o(
  f.keys
);
var i, r, a, n, l, d, s;
const z = u({
  baseStyle: {
    avatar: {},
    content: { display: "flex", flexDirection: "column", flex: 1 },
    header: {
      display: "flex",
      alignItems: "center",
      gap: 2,
      marginBottom: 2.5
    },
    root: {
      display: "flex",
      flexWrap: "wrap",
      gap: 2.5,
      paddingRight: 1
    },
    textarea: {
      ...(i = e.baseStyle) == null ? void 0 : i.field,
      ...(r = e.variants) == null ? void 0 : r.primary.field,
      ...(a = e.sizes) == null ? void 0 : a.lg.field,
      gridArea: "1 / 1 / 2 / 2",
      marginBottom: 1,
      overflow: "hidden",
      paddingX: 2,
      paddingY: 1.5,
      resize: "none",
      height: "auto",
      lineHeight: "20px"
    },
    textareaGroup: {
      ...(n = e.baseStyle) == null ? void 0 : n.group,
      ...(l = e.sizes) == null ? void 0 : l.lg.group,
      position: "relative",
      display: "grid",
      height: "auto",
      paddingRight: 10,
      borderRadius: "radius-100",
      _hover: {
        borderColor: "primary.300",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      },
      _focusWithin: {
        borderColor: "secondary.500",
        outlineColor: "secondary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      },
      "::after": {
        ...(d = e.baseStyle) == null ? void 0 : d.field,
        ...(s = e.sizes) == null ? void 0 : s.lg.field,
        content: 'attr(data-replicated-value) " "',
        lineHeight: "20px",
        marginBottom: 1,
        overflow: "hidden",
        resize: "none",
        height: "auto",
        gridArea: "1 / 1 / 2 / 2",
        whiteSpace: "pre-wrap",
        visibility: "hidden"
      }
    },
    textareaClear: {
      position: "absolute",
      right: "2px",
      top: "2px"
    },
    paragraph: {
      marginBottom: 0
    }
  },
  variants: {},
  sizes: {},
  defaultProps: {}
});
export {
  k as SavedList,
  L as SavedListAnatomy,
  I as SavedListItem,
  p as SavedListItemAnatomy,
  z as SavedListItemEdit,
  f as SavedListItemEditAnatomy
};
//# sourceMappingURL=SavedList.es.js.map
